import * as React from "react";
import styled from "styled-components";
import {
  RGB51,
  GRAY206,
  GRAY245,
  ARTICLE_CATEGORY_MAP,
} from "../../../common/constants";
import moment from "moment";
import { get, isEmpty } from "lodash";
import { needleImageCdnStart } from "../../../utils/index";

const fixedZero = (number) => `${number.replace(/\.0/g, "")}`;

const postMessage = (msg) => {
  const stringify = JSON.stringify(msg);
  window.postMessage(stringify, "*");
};

export default class KnowledgeListItem extends React.PureComponent {
  state = {
    item: {},
  };
  componentWillMount() {
    document.getElementById("root").scrollIntoView(true); // 为ture返回顶部，false为底部pv  ev ac 2 5 10 15
  }
  componentDidMount() {
    const item = get(this.props, "item", {});
    if (item) {
      this.setState({ item });
    }
  }
  calcCount = (number) => {
    let text = number;
    if (number >= 1000 && number <= 9999) {
      text = `${fixedZero((number / 1000).toFixed(1))}k`;
    } else if (number >= 10000 && number <= 99999) {
      text = `${fixedZero((number / 10000).toFixed(1))}w`;
    } else if (number >= 100000) {
      text = `${Math.round(number / 10000)}w`;
    }
    return text;
  };
  navigateDetail = () => {
    if (
      this.props.item &&
      this.props.item.appVersion &&
      this.props.item.appVersion > "1.9.8.1"
    ) {
      postMessage(this.props.item);
      return;
    }

    const { knowledgeId, patientId, fontSize } = this.props;
    const isActivity = get(this.props, "match.params.isActivity");
    if (isActivity === "true") {
      postMessage({ knowledgeId, patientId, isActivity });
    } else {
      const url = `/knowledge/BG/${knowledgeId}/${patientId}/${fontSize}`;
      // window.location.href = url;
      this.props.history.push(url);
    }
  };
  render() {
    const item = this.state.item;
    const { currentIndex, len } = this.props;
    if (isEmpty(item)) {
      return null;
    }
    return (
      <div
        onClick={() => this.navigateDetail()}
        style={{
          marginBottom: "10px",
        }}
      >
        <RootView>
          <LeftView>
            <TitleText numberOfLines={2}>{item.title}</TitleText>
            {item.publishedAt && (
              <BottomView>
                <RowView>
                  <BottomText>{ARTICLE_CATEGORY_MAP[item.category]}</BottomText>
                  <BottomText>
                    {moment(item.publishedAt).format("MM-DD")}
                  </BottomText>
                </RowView>
                <RowView>
                  <RowView>
                    <ImageView
                      src={needleImageCdnStart("K4P-42YiK.png")}
                      resizeMode="contain"
                      style={{
                        marginRight: 2,
                      }}
                    />
                    <BottomText>{this.calcCount(item.views)}</BottomText>
                  </RowView>
                  <RowView style={{ marginLeft: 10 }}>
                    <ImageView
                      src={needleImageCdnStart("Ia16rUnjM.png")}
                      resizeMode="contain"
                    />
                    <div
                      style={{
                        height: 20,
                        display: "flex",
                        alignItems: "center",
                        marginLeft: 2,
                      }}
                    >
                      <BottomText>
                        {item.sharings ? this.calcCount(item.sharings) : 0}
                      </BottomText>
                    </div>
                  </RowView>
                </RowView>
              </BottomView>
            )}
            {currentIndex !== len - 1 && <Line />}
          </LeftView>
          <RightImage
            src={
              item.avatar
                ? item.avatar
                : require("./images/img_knowledge_right.png")
            }
            resizeMode="contain"
          />
        </RootView>
      </div>
    );
  }
}

const RootView = styled.div`
  flex-direction: row;
  display: flex;
  margin-top: 10px;
`;
const LeftView = styled.div`
  flex-direction: column;
  width: 210px;
  flex: auto;
  position: relative;
  display: flex;
  justify-content: space-between;
`;
const TitleText = styled.div`
  font-size: 15px;
  line-height: 24px;
  color: #333;
  margin-right: 10px;
  font-family: PingFang SC,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,Helvetica,Arial,Hiragino Sans GB,Source Han Sans,Noto Sans CJK Sc,Microsoft YaHei,Microsoft Jhenghei,sans-serif;
`;
const BottomView = styled.div`
  flex-direction: row;
  display: fex;
  justify-content: space-between;
  margin-top: 20px;
`;
const RowView = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const BottomText = styled.div`
  font-size: 13px;
  color: #999999;
  font-family: PingFang SC,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,Helvetica,Arial,Hiragino Sans GB,Source Han Sans,Noto Sans CJK Sc,Microsoft YaHei,Microsoft Jhenghei,sans-serif;
`;
const ImageView = styled.img`
  width: 20px;
  height: 20px;
`;
const RightImage = styled.img`
  width: 112px;
  height: 84px;
  border-radius: 8px;
  flex: 0 0 112px;
  margin-left: 10px;
`;
const Line = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${GRAY245};
  position: absolute;
  bottom: -10px;
`;



// WEBPACK FOOTER //
// ./src/modules/knowledge/components/KnowledgeListItem.js